import React, { PropTypes } from 'react';
import Button from '../../common/Button';
import EstablishmentUsersTable from '../EstablishmentUsersTable/EstablishmentUsersTable';
import EstablishmentUserModal from '../EstablishmentUsersModal';
import { createEstablishmentUserObject } from '../EstablishmentUserObject';

class EstablishmentUsers extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loggedinUserId: this.props.user.userId,
            establishmentId: this.props.establishmentId,
            establishmentUsers: this.props.establishmentUsers,
            showModal: false,
            displayAlert: '',
            establishmentUserEmail: '',
            establishmentUserRole: '',
            establishmentUserId: '',
            operationType: '',
            selectedUsersList: [],
            selectedUserIdsList: [],
            isAdminUser: false
        };
        this.openEstablishmentUserModal = this.openEstablishmentUserModal.bind(this);
        this.closeEstablishmentUserModal = this.closeEstablishmentUserModal.bind(this);
        this.createEstablishmentUser = this.createEstablishmentUser.bind(this);
        this.editEstablishmentUser = this.editEstablishmentUser.bind(this);
        this.establishmentUserRoleChange = this.establishmentUserRoleChange.bind(this);
        this.establishmentUserEmailChange = this.establishmentUserEmailChange.bind(this);
        this.removeEstablishmentUserModal = this.removeEstablishmentUserModal.bind(this);
        this.selectEstablishmentUsers = this.selectEstablishmentUsers.bind(this);
        this.updateEstablishmentUser = this.updateEstablishmentUser.bind(this);
        this.removeEstablishmentUser = this.removeEstablishmentUser.bind(this);
        this.validateRemoveUser = this.validateRemoveUser.bind(this);
    }

    openEstablishmentUserModal(event) {
        event.preventDefault();
        this.setState({ showModal: true, operationType: 'C', establishmentUserEmail: '', establishmentUserRole: '', selectedUsersList: [], selectedUserIdsList: [] });
    }

    closeEstablishmentUserModal(event) {
        event.preventDefault();
        this.setState({ showModal: false });
    }

    removeEstablishmentUserModal(event) {
        event.preventDefault();
        var loggedInUser = this.state.loggedinUserId;
        var selectedUserList = this.state.selectedUserIdsList;
        var loggedInUserExist = selectedUserList.filter(function (user) {
            return (user === loggedInUser);
        }).length > 0;
        let allUsersList = this.props.establishmentUsers;
        let notSelectedList = allUsersList.filter(f => !selectedUserList.includes(f));
        var isAdminRole = notSelectedList.filter(f => { f.user_role.toLowerCase() === 'ITA Establishment Admin'.toLowerCase(); }).length > 0;

        if (selectedUserList.length < 1) {
            this.props.saveUserError("Please select at least one record.");
            this.setState({ showModal: false });
        } else if (this.props.establishmentUsers.length === this.state.selectedUserIdsList.length) {
            this.props.saveUserError("There should be at least one Establishment User.");
            this.setState({ showModal: false });
        } else if (isAdminRole) {
            this.props.saveUserError("There should be at least one Establishment Admin User Role.");
            this.setState({ showModal: false });
        } else if (loggedInUserExist) {
            this.props.saveUserError("Logged in User cannot remove themselves!!");
            this.setState({ showModal: false });
        } else {
            this.setState({ showModal: true, operationType: 'D' });
        }
    }

    updateEstablishmentUser() {
        let establishmentUsersObj = createEstablishmentUserObject();
        let updateUserSuccess = false;
        establishmentUsersObj.userId = this.state.establishmentUserId;
        establishmentUsersObj.establishmentId = this.state.establishmentId;
        establishmentUsersObj.establishmentUserRole = this.state.establishmentUserRole;
        establishmentUsersObj.operationType = 'U';
        updateUserSuccess = this.props.saveEstUser(establishmentUsersObj);
        if (updateUserSuccess) {
            this.setState({ showModal: false });
            this.props.saveUserSuccess("Establishment User Role Updated Successfully.");
        }
    }

    createEstablishmentUser() {
        const userEmail = this.state.establishmentUserEmail;
        let estUsers = this.props.establishmentUsers;
        let createUserSuccess = false;

        var emailExist = Array.isArray(estUsers) &&
          estUsers.filter(function (establishmentUser) {
            return establishmentUser.email === userEmail;
          }).length < 1;
        if (emailExist) {
            this.props.validateEstUser(this.state.establishmentUserEmail)
                .then(response => {
                    if (response.userid) {
                        let establishmentUsersObj = createEstablishmentUserObject();
                        establishmentUsersObj.userId = response.userid;
                        establishmentUsersObj.establishmentId = this.state.establishmentId;
                        establishmentUsersObj.establishmentUserRole = this.state.establishmentUserRole;
                        establishmentUsersObj.operationType = 'C';
                        createUserSuccess = this.props.saveEstUser(establishmentUsersObj);
                        if (createUserSuccess) {
                            this.setState({ showModal: false });
                            this.props.saveUserSuccess("Establishment User Created Successfully.");
                        }
                    } else {
                        this.setState({ showModal: false });
                        this.props.saveUserError("Your request cannot be processed. The email address submitted is not associated with a current ITA user. Please try again.");
                    }
                }).catch(error => {
                    throw error;
                });
        } else {
            this.setState({ displayAlert: 'User Already Exist in this Establishment' });
        }
    }

    validateRemoveUser() {
        let selectedUserList = this.state.selectedUserIdsList;
        let allUsersList = this.props.establishmentUsers;
        let notSelectedList = allUsersList.filter(f => !selectedUserList.includes(f));
        var isAdminRole = notSelectedList.filter(f => { f.user_role.toLowerCase() === 'ITA Establishment Admin'.toLowerCase(); }).length > 0;
        if (this.props.establishmentUsers.length === this.state.selectedUserIdsList.length) {
            this.props.saveUserSuccess("There should be at least one Establishment User.");
            this.setState({ showModal: false });
        } else if (!isAdminRole) {
            this.props.saveUserSuccess("There should be at least one Establishment Admin User Role.");
            this.setState({ showModal: false });
        } else {
            this.removeEstablishmentUser();
        }
    }

    removeEstablishmentUser() {
        var userList = this.state.selectedUserIdsList;
        userList.forEach((userId) => {
            let establishmentUsersObj = createEstablishmentUserObject();
            establishmentUsersObj.userId = userId;
            establishmentUsersObj.establishmentId = this.state.establishmentId;
            establishmentUsersObj.establishmentUserRole = '';
            establishmentUsersObj.operationType = 'D';
            let updateUserSuccess = this.props.saveEstUser(establishmentUsersObj);
            if (updateUserSuccess) {
                this.setState({ selectedUsersList: [], selectedUserIdsList: [] });
            }
        });
        this.setState({ showModal: false });
        this.props.saveUserSuccess("Establishment User(s) Removed Successfully.");
    }

    editEstablishmentUser(establishmentuser) {
        var establishmentUsersList = this.props.establishmentUsers;
        var singleAdminUser = false;

        if (establishmentuser.user_role.toLowerCase() === 'ITA Establishment Admin'.toLowerCase()) {

            singleAdminUser = establishmentUsersList.filter(function (user) {
                return (user.user_role === establishmentuser.user_role);
            }).length <= 1;
        }
        if (!singleAdminUser) {
            this.setState({ showModal: true, operationType: 'U', establishmentUserEmail: establishmentuser.email, establishmentUserRole: establishmentuser.user_role, establishmentUserId: establishmentuser.user_id, selectedUsersList: [], selectedUserIdsList: [] });
        } else {
            this.props.saveUserError("There must be at least one ITA Establishment Admin User!!");
        }
    }

    establishmentUserRoleChange(event) {
        this.setState({ establishmentUserRole: event.target.value });
    }

    establishmentUserEmailChange(event) {
        this.setState({ establishmentUserEmail: event.target.value });
        if (this.state.displayAlert) {
            this.setState({ displayAlert: '' });
        }
    }

    selectEstablishmentUsers(event) {
        let username = event.target.name;
        let userId = event.target.id;
        if (event.target.checked) {
            this.setState(prevState => ({ selectedUsersList: [...prevState.selectedUsersList, username] }));
            this.setState(prevState => ({ selectedUserIdsList: [...prevState.selectedUserIdsList, userId] }));
        } else {
            var userIdArray = [...this.state.selectedUserIdsList];
            var userIdIndex = userIdArray.indexOf(event.target.id);
            userIdArray.splice(userIdIndex, 1);
            this.setState({ selectedUserIdsList: userIdArray });

            var userNameArray = [...this.state.selectedUsersList];
            var userNameIndex = userNameArray.indexOf(event.target.name);
            userNameArray.splice(userNameIndex, 1);
            this.setState({ selectedUsersList: userNameArray });
        }

    }

    render() {
        let estUsers = this.props.establishmentUsers;
        let userId = this.props.user.userId;
        var isAdminUser = Array.isArray(estUsers) &&
        estUsers.filter(function (establishmentUser) {
          return (
            establishmentUser.user_id.toString() === userId.toString() &&
            establishmentUser.user_role.toLowerCase() === 'ita establishment admin'
          );
        }).length > 0;
        return (
            <div>
                <div>
                    <h2 >
                        <div className="establishment-user-table-title">Establishment Users</div></h2>
                    <div className="establishment-year-select establishment-buttons-container">
                        {isAdminUser && <Button value="Assign User" onClick={this.openEstablishmentUserModal} />}
                        {isAdminUser && <Button className="btn-cancel" value="Remove Selected User(s)" onClick={this.removeEstablishmentUserModal} />}
                    </div>
                </div>
                <div className="pull-left">Note: It may take 15 minutes for changes to reflect on the Establishment List and Establishment Details screens.</div>
                <div style={{ marginTop: 10 }}></div>
                <EstablishmentUsersTable establishmentusers={this.props.establishmentUsers} isAdminUser={isAdminUser}
                    editEstablishmentUser={this.editEstablishmentUser} selectEstablishmentUsers={this.selectEstablishmentUsers} selectedUserIdsList={this.state.selectedUserIdsList} />
                <EstablishmentUserModal showModal={this.state.showModal} closeModal={this.closeEstablishmentUserModal} operationType={this.state.operationType}
                    createEstablishmentUser={this.createEstablishmentUser} establishmentUserRoleChange={this.establishmentUserRoleChange}
                    establishmentUserEmailChange={this.establishmentUserEmailChange} emailDefaultValue={this.state.establishmentUserEmail}
                    roleDefaultOption={this.state.establishmentUserRole} removeEstablishmentUsersList={this.state.selectedUsersList} displayAlert={this.state.displayAlert}
                    updateEstablishmentUser={this.updateEstablishmentUser} removeEstablishmentUser={this.removeEstablishmentUser} />
            </div>
        );
    }
}

EstablishmentUsers.propTypes = {
    establishmentId: PropTypes.string,
    showModal: PropTypes.bool.isRequired,
    establishmentUserEmail: PropTypes.string,
    establishmentUserRole: PropTypes.string,
    establishmentUsersObj: PropTypes.object
};

export default EstablishmentUsers;


/** WEBPACK FOOTER **
 ** ./src/components/establishment/singleEstablishment/EstablishmentUsers.js
 **/